export function normalizeSupportCategory(category) {
  const value = String(category || "general").toLowerCase();
  if (value === "feature") return "feature_request";
  if (["bug", "billing", "feature_request", "general"].includes(value)) return value;
  return "general";
}

export function supportCategoryLabel(category) {
  const value = normalizeSupportCategory(category);
  if (value === "feature_request") return "Feature request";
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function supportStatusLabel(status) {
  const value = String(status || "open").toLowerCase();
  if (value === "in_progress") return "In progress";
  return value.charAt(0).toUpperCase() + value.slice(1);
}
